import { render } from "./TvmWebIframeRedirect.vue?vue&type=template&id=67857dcc&scoped=true"
import script from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"
export * from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"

import "./TvmWebIframeRedirect.vue?vue&type=style&index=0&id=67857dcc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67857dcc"],['__file',"src/Components/ChatWidget/TvmWebIframeRedirect/TvmWebIframeRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67857dcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67857dcc', __exports__)) {
    api.reload('67857dcc', __exports__)
  }
  
  module.hot.accept("./TvmWebIframeRedirect.vue?vue&type=template&id=67857dcc&scoped=true", () => {
    api.rerender('67857dcc', render)
  })

}


export default __exports__